module.exports = __webpack_public_path__ + "static/media/UMAN_figure_old.0faba01c.jpeg";